<template>
    <div class="container">
        <h1>Documentation sur Cardano et ADA</h1>
        <p>
            Vous trouverez ici, nous l'espérons, toute la documentation nécessaire sur Cardano et ADA. Ceci n'est pas
            une documentation officielle de la fondation Cardano, mais le simple fruit de notre travail.
            Utilisez le menu de gauche pour naviguer dans la documentation.
        </p>

        <h2 class="mt-5">Notre mission est de démocratiser Cardano et sa cryptomonnaie, ADA.</h2>
        <p>
            Une partie de cette mission consiste à fournir des ressources fiables sur Cardano, son fonctionnement,
            sa gouvernance, ses mécanismes et ses ambitions. Nous plongeons dans les différents sujets techniques, politiques,
            et financier afin de pouvoir vous fournir des informations de sources fiables, que nous retranscrivons, au fur et à mesure
            dans ces pages.
        </p>

        <h2 class="mt-5">Ces pages sont vivantes</h2>
        <p>
            Nous les rédigeons au fur et à mesure.<br/>
            Nous souhaitons répondre à toutes les questions et interrogations que vous pouvez avoir. Si vous ne trouvez pas la réponse à votre question,
            n'hésitez pas à nous <b><a href="/contact">contacter</a></b>. Nous ajouterons les réponses dans la documentation.
        </p>
    </div>
</template>

<script>
import createHeader from "../../js/meta.js";

export default {
    layout: 'DocLayout',
    head: createHeader({
        title: "Documentation en français sur Cardano et ADA - Stakepool.fr",
        description: "Tout savoir sur Cardano et ADA, c'est ici !"
    })
};
</script>